import React, { useContext } from "react";
import PropTypes from "prop-types";
import RefineOption from "../RefineOption/RefineOption";
import UserContext from "../../UserContext";
import * as S from "./DataSources.styles";

const DataSources = ({
  sources,
  handleDegreesToggle,
  handleBloomfireToggle,
  handleWebToggle
}) => {
  const { degrees, bloomfire, web } = sources;

  const {
    relationshipsEnabled,
    dealsAndListsEnabled,
    articlesEnabled,
    webEnabled
  } = useContext(UserContext);

  return (
    <S.Container>
      <S.Header>
        <S.Title>Data Sources</S.Title>
      </S.Header>
      <S.Options>
      {relationshipsEnabled && <RefineOption
          handleToggle={handleDegreesToggle}
          label="Orion Relationships"
          selected={degrees}
        />}

      {articlesEnabled && <RefineOption
          handleToggle={handleBloomfireToggle}
          label="Orion Insights"
          selected={bloomfire}
        />}

      {webEnabled && <RefineOption
          handleToggle={handleWebToggle}
          label="Web"
          selected={web}
        />}
          
      </S.Options>
    </S.Container>
  );
};

DataSources.propTypes = {
  sources: PropTypes.object,
  handleDegreesToggle: PropTypes.func,
  handleBloomfireToggle: PropTypes.func,
  handleWebToggle: PropTypes.func,
};

DataSources.defaultProps = {
  sources: {
    degrees: true,
    bloomfire: true,
    web: true,
  },
};

export default DataSources;
